import React, { useMemo, useState } from 'react';

import { Flags } from './FlagsContext';

export interface FlagsValueContextT {
  flags: Flags;
  setFlags: (flags: Flags) => void;
}

export const FlagsValueContext = React.createContext<FlagsValueContextT>({
  flags: [],
  setFlags: () => undefined,
});

export const FlagsValueProvider = ({ children }: { children: React.ReactNode | React.ReactNode[] }) => {
  const [flagsData, setFlagsData] = useState<Flags>([]);
  const value: FlagsValueContextT = useMemo(() => {
    return {
      flags: flagsData,
      setFlags: setFlagsData,
    };
  }, [flagsData, setFlagsData]);
  return <FlagsValueContext.Provider value={value}>{children}</FlagsValueContext.Provider>;
};

export const useFeatureFlagsValue = () => {
  const context = React.useContext(FlagsValueContext);

  if (context === undefined) {
    throw new Error('useFlags must be used within a FlagsValueProvider');
  }

  return context;
};
